import axios from 'axios'
import { i18n, fallbackLocale } from '@src/localization/config'

const STORAGE_LEGACY_APP_LOCALE = 'da.legacy-app.locale'

export const state = {
  currentLanguage: window.document_language || fallbackLocale,
  supportedLanguages: i18n.supportedLanguages,
}

export const getters = {}

export const mutations = {}

export const actions = {
  init({ state, commit, dispatch }) {
    dispatch('fetchLocale', fallbackLocale)
    dispatch('setLocale', state.currentLanguage)
  },

  setLocale({ commit, dispatch }, locale) {
    const savedLocale = storage.getItem(`${STORAGE_LEGACY_APP_LOCALE}.${locale}`)

    if (savedLocale) {
      i18n.setLocaleMessage(locale, savedLocale)
    }

    i18n.locale = locale
    dispatch('fetchLocale', locale)
  },

  fetchLocale({ commit }, locale) {
    axios.get(`/static/${process.env.VUE_APP_NAME}/localization/${locale}.json?t=${+(new Date)}`)
      .then(({ data }) => {
        storage.setItem(`${STORAGE_LEGACY_APP_LOCALE}.${locale}`, data)

        i18n.setLocaleMessage(locale, data)
      })
  },
}
